import { safeGet } from '@src/helpers'
import { isWebview } from '@src/helpers/webviews'

export function canDisplayAccountNotRecognisedScreen(state) {
  return !!state.ssoAccountNotRecognised
}

export function canDisplayWrongPasswordScreen(state) {
  return state.wrongPasswordUserProviders.length && !isWebview()
}

export function getWrongPasswordUserProvidersState(data) {
  const userProviders = []
  for (let i = 0; i < data.providers.length; i++) {
    if (data.providers[i].provider === 'google_oauth2') {
      userProviders.push('Google')
    } else {
      userProviders.push('Facebook')
    }
  }
  return userProviders
}

export function isCountryUk(props) {
  return safeGet(['params', 'country'], props) === 'uk'
}
